<div class="list-container">
  <mat-list #list searchExpr="searchExpr" searchMode="contains">
    @for(item of itemList;track item){
    <div (innerHtml)="templateCallback()(item)"></div>
    <mat-divider></mat-divider>
    }
  </mat-list>
</div>
